import { useEffect, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import { Autoplay, Pagination, Navigation } from "swiper/modules";

function ProductPhotos({ images }) {
  const [mainImage, setMainImage] = useState("");

  useEffect(() => {
    if (images && images.length > 0) {
      setMainImage(images[0].secure_url);
    }
  }, [images]);
  const handleImageClick = (imageUrl) => {
    setMainImage(imageUrl);
  };

  return (
    <div className="product-photos d-flex flex-wrap flex-grow-1 col-lg-12">
      {/* Desktop View */}
      <div className="d-none d-lg-flex flex-column w-100">
        {/* Main images at top */}
        <div className="d-flex flex-nowrap justify-content-center mb-3 gap-3">
          <img
            src={mainImage}
            alt=""
            className="col-6 main-image"
            style={{ maxHeight: "400px", objectFit: "contain" }}
          />
        </div>

        {/* Thumbnail images below */}
        <div className="d-flex flex-wrap justify-content-center gap-2">
          {images?.map((image, index) => (
            <div
              key={index}
              className={`thumbnail ${mainImage === image.secure_url}`}
              onClick={() => handleImageClick(image.secure_url)}
            >
              <img
                src={image.secure_url}
                alt=""
                style={{
                  width: "80px !important",
                  maxHeight: "80px",
                  maxWidth: "80px",
                  minHeight: "80px",
                  minWidth: "80px",
                  height: "80px",
                  objectFit: "cover",
                  cursor: "pointer",
                  border:
                    mainImage === image.secure_url
                      ? "2px solid #007bff"
                      : "1px solid #ddd",
                }}
              />
            </div>
          ))}
        </div>
      </div>

      {/* Mobile View - Swiper */}
      <div className="mb-5 d-lg-none d-flex justify-content-center w-100">
        <Swiper
          slidesPerView={1}
          spaceBetween={30}
          pagination={{ clickable: true }}
          autoplay={{
            delay: 2500,
            disableOnInteraction: false,
          }}
          loop={true}
          modules={[Pagination, Autoplay, Navigation]}
          className="mySwiper w-100"
        >
          {images?.map((image, index) => (
            <SwiperSlide key={index} className="d-flex justify-content-center">
              <img
                src={`${image.secure_url}`}
                alt=""
                style={{ maxHeight: "400px", objectFit: "contain" }}
              />
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </div>
  );
}

export default ProductPhotos;
